export default "__VITE_ASSET__CsW7z2s5__"